import {
    GET_SEMESTERS_FAIL,
    GET_SEMESTERS_SUCCESS,
    ADD_SEMESTER_SUCCESS,
    ADD_SEMESTER_FAIL,
    UPDATE_SEMESTER_SUCCESS,
    UPDATE_SEMESTER_FAIL,
    DELETE_SEMESTER_SUCCESS,
    DELETE_SEMESTER_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    semesters: [],
    error: null,
    loading: true
};

const semesterReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des interships
        case GET_SEMESTERS_SUCCESS:
            return {
                ...state,
                semesters: action.payload.semesters, // tableau d'objets intership
                loading: false,
                error: null
            };

        case GET_SEMESTERS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une intershipe
        case ADD_SEMESTER_SUCCESS:
            return {
                ...state,
                semesters: [action.payload, ...state.semesters], // ajoute au début du tableau
                error: null
            };

        case ADD_SEMESTER_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une intershipe
        case UPDATE_SEMESTER_SUCCESS:
            return {
                ...state,
                semesters: state.semesters.map(semester =>
                    semester.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet intership
                        : semester
                ),
                error: null
            };

        case UPDATE_SEMESTER_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une intershipe
        case DELETE_SEMESTER_SUCCESS:
            return {
                ...state,
                semesters: state.semesters.filter(
                    semester => semester.id !== action.payload
                ),
                error: null
            };


        case DELETE_SEMESTER_FAIL:
            return {
                ...state,
                error: action.payload
            };
        case "RESET_LAST_ACTION_SUCCESS":
            return { 
                ...state, 
                lastActionSuccess: false 
            };

        default:
            return state;
    }
};

export default semesterReducer;
